import React, { Component } from 'react';
import {
  Col, Container, Row,
} from 'reactstrap';
import Input from 'components/forms/Input';
import Table from 'components/tables';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableCell from 'components/tables/tableCell';
import TableSortLabel from 'components/tables/tableSortLabel';
import TableRow from 'components/tables/tableRow';
import Button from 'components/buttons/Button';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import axios from 'axios';
import { debounce, noop } from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import ChevronUpIcon from 'mdi-react/ChevronUpIcon';
import ClockOutlineIcon from 'mdi-react/ClockOutlineIcon';
import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import { Can, AbilityContext } from 'utils/permissions';
import { withStyles } from '@material-ui/core';
import moment from 'moment';

import { stripDecimalsAndFormat, calculatePercentage } from 'utils/misc';
import Pagination from 'components/pagination/Pagination';
import { updateCampaign, getCampaigns, setCampaignBuilderOpen } from 'redux/actions/campaignActions';
import NoResults from 'components/NoResults';
import PageTitle from 'components/titles/PageTitle';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import { campaignDetailUrl } from 'constants/routing';
import { DATE_FORMAT_VERBOSE } from 'constants/config';
import { getBadgeStatus, STATUS_CHANGEABLE } from 'constants/campaign';
import {
  DynamicFilter,
  CampaignManagersFilter,
  AccountsFilter,
  CampaignStatusFilter,
  EmailServiceProviderFilter,
} from 'components/filters';
import { injectSatismeter } from 'utils/satismeter';
import CampaignStats from './CampaignStats';
import StatusBadge from '../StatusBadge';

const DYNAMIC_MENU_OPTIONS = {
  managers: 'manager',
  accounts: 'account',
  status: 'status',
  esp: 'esp',
};

class CampaignList extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    getCampaigns: PropTypes.func.isRequired,
    updateCampaign: PropTypes.func.isRequired,
    setCampaignBuilderOpen: PropTypes.func.isRequired,
    user: PropTypes.shape({
      pk: PropTypes.number,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      isAuthenticated: PropTypes.bool,
      user_groups: PropTypes.array,
    }).isRequired,
    campaigns: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      count: PropTypes.number,
      next: PropTypes.string,
      previous: PropTypes.string,
      results: PropTypes.array,
      potential_reach_sum: PropTypes.number,
      total_people: PropTypes.number,
      total_delivered: PropTypes.number,
      total_people_contacted: PropTypes.number,
      interested_sum: PropTypes.number,
      opens_sum: PropTypes.number,
      replies_sum: PropTypes.number,
      potential_reach: PropTypes.number,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      filterParams: {
        search: null,
        statuses: [],
        account__id: [],
        email_service_provider_config__id: [],
        campaign_manager__id: [],
        ordering: null,
      },
      isOrderingReversed: false,
      isSoftLoading: false,
      isConfirmOffModalOpen: false,
      campaign: null,
      order: null,
      ongoingRequestCancel: noop,
    };
    this.emitChangeDebounced = debounce(this.emitChange, 400);
  }

  componentDidMount() {
    injectSatismeter();
    this.fetchList();
  }

  componentWillUnmount() {
    this.emitChangeDebounced.cancel();
  }


  onResetSelectedFilter = (filter) => {
    const newParams = {};
    switch (filter) {
      case DYNAMIC_MENU_OPTIONS.status:
        newParams.statuses = [];
        break;
      case DYNAMIC_MENU_OPTIONS.managers:
        newParams.campaign_manager__id = [];
        break;
      case DYNAMIC_MENU_OPTIONS.accounts:
        newParams.account__id = [];
        break;
      case DYNAMIC_MENU_OPTIONS.esp:
        newParams.email_service_provider_config__id = [];
        break;
      default:
        break;
    }
    this.setState({ filterParams: { ...this.state.filterParams, ...newParams } });
  }

  onResetFilters = () => {
    const newState = this.state;
    newState.filterParams.statuses = [];
    newState.filterParams.account__id = [];
    newState.filterParams.campaign_manager__id = [];
    newState.filterParams.email_service_provider_config__id = [];
    this.setState(newState, () => this.fetchList(newState.filterParams));
  }

  onDeleteFilter = (selectedFilter) => {
    const newState = this.state;

    switch (selectedFilter) {
      case DYNAMIC_MENU_OPTIONS.status:
        newState.filterParams.statuses = [];
        break;
      case DYNAMIC_MENU_OPTIONS.managers:
        newState.filterParams.campaign_manager__id = [];
        break;
      case DYNAMIC_MENU_OPTIONS.accounts:
        newState.filterParams.account__id = [];
        break;
      case DYNAMIC_MENU_OPTIONS.esp:
        newState.filterParams.email_service_provider_config__id = [];
        break;
      default:
        break;
    }
    this.setState(newState, () => this.fetchList(newState.filterParams));
  }

  onStatusChange = (status, campaign) => (
    status ? this.handleStatusChange(status, campaign) : this.toggleIsConfirmOffModalOpen(campaign)
  );

  prepareParams(params, newIsOrderingReversed = this.state.order === 'desc') {
    const prepParams = { ...this.state.filterParams, ...params };
    // in API we will consume accounts as string ( 'accountID1, accountID2' )
    if (prepParams.account__id.length > 0) {
      // eslint-disable-next-line max-len
      prepParams.account__id = prepParams.account__id.map(l => (l.value)).join(', ');
    }
    // in API we will consume statuses as string ( 'active, complete' )
    if (prepParams.statuses.length > 0) {
      prepParams.statuses = prepParams.statuses.map(l => (l.value))
        .join(', ');
    }
    // in API we will consume managers as string ( 'managerID1, managerID2' )
    if (prepParams.campaign_manager__id.length > 0) {
      prepParams.campaign_manager__id = prepParams.campaign_manager__id.map(l => (l.value))
        .join(', ');
    }
    // in API we will consume esp as string ( 'espID1, espID2' )
    if (prepParams.email_service_provider_config__id.length > 0) {
      prepParams.email_service_provider_config__id = prepParams.email_service_provider_config__id.map(l => (l.value))
        .join(', ');
    }
    // in API we need to set ordering with minus sign if descending
    if (prepParams.ordering) {
      prepParams.ordering = `${newIsOrderingReversed ? '-' : ''}${prepParams.ordering}`;
    }
    return prepParams;
  }

  fetchList = async (filterParams, newIsOrderingReversed, seamless = false) => {
    const preparedParams = this.prepareParams(filterParams, newIsOrderingReversed);
    const paramsForState = { ...this.state.filterParams, ...filterParams };
    // when we fetchList in DidMount we receive newIsOrderingReversed as undefined
    let newIsOrderingReversedMod = newIsOrderingReversed;
    if (newIsOrderingReversed === undefined || newIsOrderingReversed === null) {
      newIsOrderingReversedMod = this.state.isOrderingReversed;
    }
    this.setState({
      filterParams: paramsForState,
      isOrderingReversed: newIsOrderingReversedMod,
    });
    const isOrderingReversedChanged = this.state.isOrderingReversed !== newIsOrderingReversedMod;
    const isOrderingTypeChanged = this.state.filterParams.ordering !== paramsForState.ordering;
    const isOrderingChanged = isOrderingReversedChanged || isOrderingTypeChanged;
    if (isOrderingChanged) {
      this.setState({ isSoftLoading: true });
    }
    this.state.ongoingRequestCancel();
    const cancelToken = new axios.CancelToken((c) => { this.setState({ ongoingRequestCancel: c }); });
    await this.props.getCampaigns(preparedParams, isOrderingChanged || seamless, cancelToken);
    if (isOrderingChanged) {
      this.setState({ isSoftLoading: false });
    }
  }

  handleOrdering(ordering) {
    const isToggleReversedOrdering = this.state.filterParams.ordering === ordering;
    let newIsOrderingReversed = this.state.isOrderingReversed;
    if (isToggleReversedOrdering) {
      newIsOrderingReversed = !newIsOrderingReversed;
    }
    this.fetchList({ ordering }, newIsOrderingReversed);
    this.setState({ order: newIsOrderingReversed ? 'desc' : 'asc' });
  }

  handleStatusChange = async (status, campaign) => {
    this.setState({ isConfirmOffModalOpen: false });
    await this.props.updateCampaign(campaign.id, { status }, true);
    await this.fetchList(null, null, true);
  }

  handleChangeStatus = (statuses) => {
    this.fetchList({ statuses });
  }

  emitChange(value) {
    this.fetchList({ search: value });
  }

  handleChangeAccounts = (accounts) => {
    this.fetchList({ account__id: accounts });
  }

  handleChangeESPs = (esps) => {
    this.fetchList({ email_service_provider_config__id: esps });
  }

  handleChangeManagers = (managers) => {
    this.fetchList({ campaign_manager__id: managers });
  }

  toggleIsConfirmOffModalOpen = (campaign) => {
    this.setState({
      isConfirmOffModalOpen: !this.state.isConfirmOffModalOpen,
      campaign,
    });
  }

  renderOrderingIcon = (orderingParam) => {
    const { filterParams: { ordering }, isOrderingReversed } = this.state;
    return (
      <React.Fragment>
        {ordering === orderingParam && !isOrderingReversed && <ChevronUpIcon />}
        {ordering === orderingParam && isOrderingReversed && <ChevronDownIcon />}
      </React.Fragment>
    );
  }

  render() {
    const { history } = this.props;
    const { filterParams, campaign, isConfirmOffModalOpen } = this.state;
    const tableClass = classNames({
      'volt-table': true,
    });
    const campaignName = campaign ? campaign.name : '';

    return (
      <Can I="see" a="Campaign">
        <ConfirmationModal
          open={isConfirmOffModalOpen}
          onBackdropClick={() => this.toggleIsConfirmOffModalOpen(false)}
          title="Warning"
          confirmLabel="Accept"
          confirmBtnColor="primaryCTA"
          onConfirmClick={() => this.handleStatusChange(false, campaign)}
          onCancelClick={() => this.toggleIsConfirmOffModalOpen(false)}
        >
          <span>Are you sure you want to turn off <strong>&#34;{campaignName}&#34;</strong>?</span>
          <br />It will continue to poll responses but stop sending emails for all sequences.
        </ConfirmationModal>
        <Container>
          <PageTitle>Campaigns</PageTitle>
          <Row>
            <Col className="campaign-list mb-super">
              <div className="d-flex flex-sm-row flex-column position-relative">
                <div className="mr-2">
                  <DynamicFilter
                    menuDescription="Filter by"
                    onResetSelectedFilter={this.onResetSelectedFilter}
                    onResetFilters={this.onResetFilters}
                    options={[
                      {
                        key: DYNAMIC_MENU_OPTIONS.managers,
                        menuLabel: 'Managers',
                        onDeleteFilter: this.onDeleteFilter,
                        component: <CampaignManagersFilter
                          value={filterParams.campaign_manager__id}
                          onChange={this.handleChangeManagers}
                        />,
                      },
                      {
                        key: DYNAMIC_MENU_OPTIONS.accounts,
                        menuLabel: 'Accounts',
                        onDeleteFilter: this.onDeleteFilter,
                        component: <AccountsFilter
                          value={filterParams.account__id}
                          onChange={this.handleChangeAccounts}
                        />,
                      },
                      {
                        key: DYNAMIC_MENU_OPTIONS.status,
                        menuLabel: 'Status',
                        onDeleteFilter: this.onDeleteFilter,
                        component: <CampaignStatusFilter
                          value={filterParams.statuses}
                          onChange={this.handleChangeStatus}
                        />,
                      },
                      {
                        key: DYNAMIC_MENU_OPTIONS.esp,
                        menuLabel: 'Sending Email',
                        onDeleteFilter: this.onDeleteFilter,
                        component: <EmailServiceProviderFilter
                          value={filterParams.email_service_provider_config__id}
                          onChange={this.handleChangeESPs}
                        />,
                      },
                    ]}
                    handleChangeAccounts={this.handleChangeAccounts}
                    handleChangeStatus={this.handleChangeStatus}
                    filterParams={this.state.filterParams}
                    onDeleteFilter={this.onDeleteFilter}
                    initialFilters={['status']}
                  />
                </div>
                <div className="search-input-form w-100">
                  <Input
                    inputProps={{ type: 'search' }}
                    rightIcon="search"
                    onChange={e => this.emitChangeDebounced(e.target.value)}
                    placeholder="Search"
                  />
                </div>
                <Can I="create" a="Campaign">
                  <div className="btn-container ml-2">
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => this.props.setCampaignBuilderOpen(true)}
                      size="large"
                      startIcon={<PlusCircleOutlineIcon />}
                      data-intercom-target="Add campaign button"
                    >
                      Create Campaign
                    </Button>
                  </div>
                </Can>
                <div className="ml-2">
                  <Button
                    size="large"
                    variant="outlined"
                    startIcon={<ClockOutlineIcon />}
                    onClick={() => history.push('timelines')}
                  >
                    Timeline
                  </Button>
                </div>
              </div>

              {this.props.campaigns.results.length >= 1 &&
                <CampaignStats
                  totalPeople={this.props.campaigns.total_people}
                  totalDelivered={this.props.campaigns.total_delivered}
                  totalPeopleContacted={this.props.campaigns.total_people_contacted}
                  opensSum={this.props.campaigns.opens_sum}
                  repliesSum={this.props.campaigns.replies_sum}
                  campaignCount={this.props.campaigns.count}
                  potentialReachSum={this.props.campaigns.potential_reach_sum}
                  interestedSum={this.props.campaigns.interested_sum}
                />
              }

              {(!this.props.campaigns.loading && this.props.campaigns.results.length >= 1) &&
                <React.Fragment>
                  <div className="w-100 overflow-auto">
                    <Table className={tableClass} loading={this.state.isSoftLoading}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            onClick={() => this.handleOrdering('name')}
                            className="sortable truncate-text--200"
                          >
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="name"
                            >
                              <span>Campaign name</span>
                            </TableSortLabel>
                          </TableCell>
                          <TableCell
                            onClick={() => this.handleOrdering('account__name')}
                            className="sortable truncate-text--200"
                          >
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="account__name"
                            >
                              Account
                            </TableSortLabel>
                          </TableCell>
                          <TableCell
                            onClick={() => this.handleOrdering('launch_date')}
                            className="sortable"
                          >
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="launch_date"
                            >
                              Launch Date
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            Status
                          </TableCell>
                          <TableCell onClick={() => this.handleOrdering('stat_people')} className="sortable">
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="stat_people"
                            >
                              People
                            </TableSortLabel>
                          </TableCell>
                          <TableCell onClick={() => this.handleOrdering('stat_opens_percentage')} className="sortable">
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="stat_opens_percentage"
                            >
                              Open rate
                            </TableSortLabel>
                          </TableCell>
                          <TableCell
                            onClick={() => this.handleOrdering('stat_replies_percentage')}
                            className="sortable"
                          >
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="stat_replies_percentage"
                            >
                              Reply
                            </TableSortLabel>
                          </TableCell>
                          <TableCell
                            onClick={() => this.handleOrdering('potential_reach')}
                            className="sortable"
                          >
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="potential_reach"
                            >
                              Potential Reach
                            </TableSortLabel>
                          </TableCell>
                          <TableCell
                            onClick={() => this.handleOrdering('stat_interested_percentage')}
                            className="sortable"
                          >
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="stat_interested_percentage"
                            >
                              Interested
                            </TableSortLabel>
                          </TableCell>
                          <Can I="see" a="Bounced rate">
                            <TableCell
                              onClick={() => this.handleOrdering('stat_bounced_percentage')}
                              className="sortable"
                            >
                              <TableSortLabel
                                order={this.state.order}
                                orderBy={this.state.filterParams.ordering}
                                property="stat_interested_percentage"
                              >
                                Bounced
                              </TableSortLabel>
                            </TableCell>
                          </Can>
                          <TableCell onClick={() => this.handleOrdering('stat_delivered')} className="sortable">
                            <TableSortLabel
                              order={this.state.order}
                              orderBy={this.state.filterParams.ordering}
                              property="stat_delivered"
                            >
                              Delivered
                            </TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>

                        {!this.props.campaigns.loading &&
                        this.props.campaigns.results.map(c => (
                          <TableRow key={c.id}>
                            <TableCell className="truncate-text--200">
                              <Link to={campaignDetailUrl(c.id)}>
                                {c.name}
                              </Link>
                            </TableCell>
                            <TableCell className="truncate-text--200">{c.account_name}</TableCell>
                            <TableCell className="truncate-text--200">
                              {c.launch_date ? moment(c.launch_date).local().format(DATE_FORMAT_VERBOSE) : 'N/A'}
                            </TableCell>
                            <TableCell>
                              <StatusBadge
                                status={getBadgeStatus(c)}
                                handleStatusChange={
                                  this.context.can('toggle', 'Campaign') &&
                                    STATUS_CHANGEABLE.includes(getBadgeStatus(c)) ?
                                    arg => this.onStatusChange(arg, c) : null
                                }
                              />
                            </TableCell>
                            <TableCell>{c.stat_people}</TableCell>
                            <TableCell>
                              {
                                c.stat_unique_opens !== 0 && c.stat_unique_delivered !== 0 ?
                                  `${calculatePercentage(c.stat_unique_delivered, c.stat_unique_opens)}%
                                (${c.stat_unique_opens})` :
                                  '-'
                              }
                            </TableCell>
                            <TableCell>
                              {
                                c.stat_unique_replies !== 0 && c.stat_unique_delivered !== 0 ?
                                  `${calculatePercentage(c.stat_unique_delivered, c.stat_unique_replies)}%
                                (${c.stat_unique_replies})` :
                                  '-'
                              }
                            </TableCell>
                            <TableCell>
                              {parseInt(c.potential_reach, 10)
                                ? stripDecimalsAndFormat(c.potential_reach)
                                : '-'
                              }
                            </TableCell>
                            <TableCell>
                              {
                                c.stat_interested !== 0 && c.stat_unique_delivered !== 0 ?
                                    `${calculatePercentage(c.stat_unique_delivered, c.stat_interested)}%
                                    (${c.stat_interested})` :
                                    '-'
                              }
                            </TableCell>
                            <Can I="see" a="Bounced rate">
                              <TableCell>
                                {
                                  c.stat_bounced !== 0 && c.stat_unique_delivered !== 0 ?
                                      `${calculatePercentage(c.stat_unique_attempted_sends, c.stat_bounced)}%
                                      (${c.stat_bounced})` :
                                      '-'
                                }
                              </TableCell>
                            </Can>
                            <TableCell>
                              {
                                c.stat_delivered !== 0 ?
                                  c.stat_delivered :
                                  '-'
                              }
                            </TableCell>
                          </TableRow>
                        ))
                        }
                      </TableBody>
                    </Table>
                  </div>
                </React.Fragment>
              }
              <NoResults
                className="mt-3"
                loading={this.props.campaigns.loading}
                results={this.props.campaigns.results}
              />
              {!this.props.campaigns.loading &&
                <Pagination
                  items={this.props.campaigns}
                  onChangePage={this.props.getCampaigns}
                  params={this.prepareParams(filterParams)}
                />
              }
            </Col>
          </Row>
        </Container>
      </Can>
    );
  }
}

const styles = theme => ({
  timelineBtn: {
    height: '3rem',
    fontFamily: theme.typography.fontFamily,
    padding: '0.063rem 0.563rem',
    border: `0.063rem solid ${theme.palette.secondary['300']}`,
    borderRadius: '0.375rem',
    color: `${theme.palette.gray.contrastText} !important`,
    backgroundColor: theme.palette.white,
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover, &$opened': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary['100'],
      border: `1px solid ${theme.palette.primary.main}`,
      '& $filterIcon': {
        fill: theme.palette.primary.main,
      },
    },
  },
});

CampaignList.contextType = AbilityContext;

export default compose(
  connect(
    state => ({
      user: state.user,
      campaigns: state.campaigns,
    }),
    {
      getCampaigns,
      updateCampaign,
      setCampaignBuilderOpen,
    },
  ),
  withRouter,
  withStyles(styles),
  withNamespaces('common'),
)(CampaignList);
